<template>
  <main id="clientAccountant" v-if="config.status.authed">
    <Toolbar ref="toolbar"
      :item="getItem"
      @select="update"
    />
    <v-progress-linear indeterminate v-if="isInitializing || isLoading" class="ma-0" color="blue" />
    <v-card>
      <v-navigation-drawer app clipped right
        v-model="config.status.active"
        width="300"
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title"><v-icon small class="mr-2">fal fa-copy</v-icon>請求一覧</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider />
        <v-list nav>
          <template v-for="charge in getCharges">
            <v-list-group sub-group :key="charge.id" :data-id="charge.id" prepend-icon="">
              <template v-slot:activator>
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-right">
                      <span class="font-weight-bold">入金期日：</span>
                      <span class="mr-2">{{ charge.date.due.text }}</span>
                      <span class="font-weight-bold">請求日：</span>
                      <span>{{ charge.date.charged.text }}</span>
                    </v-list-item-subtitle>
                    <v-list-item-title class="text-right">{{ charge.sum.text }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-menu bottom left offset-y :close-on-click="true">
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on" :loading="isLoading">
                          <v-icon small color="secondary">fa-ellipsis-v</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item v-if="!charge.media">
                          <v-list-item-icon><v-icon small>fal fa-link</v-icon></v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>ファイル連携</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-else @click="$refs.previewer.open(charge.media)">
                          <v-list-item-icon><v-icon small>fal fa-file-excel</v-icon></v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>元ファイル確認</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-list-item-action>
                </v-list-item>
              </template>
              <v-list-item v-for="child in charge.children" :key="child.id">
                <v-list-item-content>
                  <v-list-item-subtitle>{{ child.label.text }}</v-list-item-subtitle>
                  <v-list-item-title>{{ child.sum.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-divider :key="charge.id + '-d'" />
          </template>
          <v-list-item v-if="!hasCharges" class="caption justify-center">
            <v-progress-circular indeterminate v-if="isInitializing || isLoading" width="3" />
            <span v-else>登録している請求書はございません</span>
          </v-list-item>
        </v-list>
        <v-footer fixed>
          <v-btn text v-if="$vuetify.breakpoint.mdAndDown" @click="$set(config.status, 'active', false)">閉じる</v-btn>
          <div class="flex-grow-1" />
          <v-btn depressed color="secondary" @click="$refs.biller.open()"><v-icon small class="mr-2">fal fa-file-excel</v-icon>追加する</v-btn>
        </v-footer>
      </v-navigation-drawer>
      <v-list class="pa-0">
        <v-list-item>
          <v-row dense>
            <v-col cols="8" class="text-left" style="border-right: 1px solid rgba(0,0,0,.12)">項目</v-col>
            <v-col cols="4" class="text-left">残高</v-col>
          </v-row>
        </v-list-item>
        <v-divider />
        <template v-for="(item, idx) in getChildren">
          <v-divider v-if="idx !== 0" :key="item.id + 'd'" />
          <v-list-item :key="item.id" class="b-item">
            <v-row dense>
              <v-col cols="8" class="px-2" style="border-right: 1px solid rgba(0,0,0,.12)">
                <v-list-item-subtitle>
                  <template v-for="(type, jdx) in item.type">
                    <v-icon :key="item.id + 'arrow' + jdx" v-if="type && jdx !== 0" small class="mx-1">fal fa-chevron-right</v-icon>
                    <v-chip :key="item.id + 'i' + jdx" v-if="type" :small="jdx === 0" :x-small="jdx !== 0" :color="(meta.types[type.value] && jdx === 0) ? meta.types[type.value].color : ''" :text-color="jdx === 0 ? 'white' : ''">{{type.text}}</v-chip>
                  </template>
                </v-list-item-subtitle>
                <v-list-item-title :class="['text-right', {'red--text': (meta.types[item.type[0].value] && meta.types[item.type[0].value].sign === 'negative')}]">{{item.sum.text}}</v-list-item-title>
              </v-col>
              <v-col cols="4" class="px-2">
                <v-list-item-subtitle>
                  <v-chip small>{{item.date.text}}</v-chip>
                </v-list-item-subtitle>
                <v-list-item-title :class="['text-right', {'red--text': item.balance.value < 0}]">{{item.balance.text}}</v-list-item-title>
              </v-col>
            </v-row>
          </v-list-item>
        </template>
      </v-list>
      <v-btn fab fixed bottom right v-if="$vuetify.breakpoint.mdAndDown" @click="$set(config.status, 'active', true)"><v-icon small>fal fa-list</v-icon></v-btn>
    </v-card>
    <!-- <v-container fluid grid-list-md
      v-if="!isInitializing"
      class="px-1 py-1"
    >
      <v-layout row
        v-if="isSetItem"
        class="amber text-right"
      >
        <v-flex pa-2>利益：{{ printProfit }}</v-flex>
      </v-layout>
      <v-layout v-else>
        <v-flex xs12>
          <p class="headline text-xs-center grey--text">会計がございません。【機能】より会計を追加してください。</p>
        </v-flex>
      </v-layout>
    </v-container> -->
    <!-- <div id="legacy" v-if="isSetItem">
      <iframe ref="legacyFrame" name="legacyFrame" src="" @load="onLoad"></iframe>
      <form id="legacyForm" ref="legacyForm" target="legacyFrame" :action="printURL" method="POST">
        <input type="hidden" name="firebaseToken" ref="legacyToken" value="" />
      </form>
    </div> -->
    <PreviewModal ref="previewer"></PreviewModal>
    <BillModal ref="biller" :item="getItem" @done="update"></BillModal>
  </main>
</template>

<script>
import Toolbar from './toolbar'
import PreviewModal from '@/components/filers/components/modals/preview'
import BillModal from './modals/bill'
export default {
  name: 'clientAccountant',
  components: {
    Toolbar,
    PreviewModal,
    BillModal
  },
  data () {
    return {
      config: {
        status: {
          authed: false,
          loading: false,
          active: true
        }
      },
      meta: {
        types: {
          payment: {
            sign: 'negative',
            color: 'red darken-4'
          },
          dcpayment: {
            sign: 'negative',
            color: 'red darken-4'
          },
          prefund: {
            sign: 'negative',
            color: 'red darken-4'
          },
          deposite: {
            sign: 'positive',
            color: 'green'
          },
          drefund: {
            sign: 'positive',
            color: 'green'
          },
          dcrefund: {
            sign: 'positive',
            color: 'green'
          },
          'carry-out': {
            sign: 'negative',
            color: 'secondary'
          },
          'carry-in': {
            sign: 'positive',
          }
        },
      },
      store: {
        item: null
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    onLoad: function (e) {
      if (this.$refs.toolbar) {
        this.$refs.toolbar.get()
      } else {
        setTimeout(this.onLoad, 1000)
      }
    },
    init: function () {
      this.auth()
      this.$set(this.config.status, 'active', !this.$vuetify.breakpoint.mdAndDown)
    },
    auth: function () {
      let auths = this.$store.getters['author/get']('authority')
      let permit = this.$route.meta.permit
      if (!auths.includes(permit)) {
        this.$router.push('/')
      } else {
        this.$set(this.config.status, 'authed', true)
      }
    },
    get: function (req) {
      const { id } = req || {}
      const cid = this.$route.params.id
      if (id) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(`${this.$url.api}cbook/get/item/${id}`, { cid }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            this.$set(this.config.status, 'loading', false)
            if (res.data && res.data.success) {
              this.$set(this.store, 'item', Object.assign({}, req, res.data.data))
            }
          })
        }).catch(err => {
          console.log(err)
          this.$set(this.config.status, 'loading', false)
        })
      }
    },
    update: function (req) {
      console.log(req)
      const { type, item, forceLoad } = req || {}
      if (type === 'item') {
        const { id } = item || {}
        const oldItem = this.store.item || { id: '' }
        if (id) {
          this.get(item)
          this.$set(this.store, 'item', item)
          if (oldItem.id !== id || forceLoad) {
            this.$firebase.auth().currentUser.getIdToken(true).then(token => {
              this.$refs.legacyToken.value = token
              this.$nextTick(() => {
                this.$refs.legacyForm.submit()
              })
            })
          }
        } else {
          this.$set(this.store, 'item', {})
          this.$set(this.config.status, 'loading', false)
        }
      } else if (type === 'charges' && this.store.item.charges) {
        const idx = this.store.item.charges.findIndex(it => { return it.id === item.id })
        if (idx >= 0) {
          this.store.item.charges.splice(idx, 1, item)
        } else {
          this.store.item.charges.push(item)
        }
      }
      // if (req && req.id) {
      //   this.$set(this.store, 'item', req)
      //   this.$firebase.auth().currentUser.getIdToken(true).then(token => {
      //     this.$refs.legacyToken.value = token
      //     this.$nextTick(() => {
      //       this.$refs.legacyForm.submit()
      //     })
      //   })
      // } else {
      //   this.$set(this.store, 'item', {})
      // }
    }
  },
  computed: {
    isDeveloping () {
      return this.$store.getters['author/get']('dev')
    },
    isInitializing () {
      return this.store.item == null
    },
    isLoading () {
      return this.config.status.loading
    },
    isSetItem () {
      return (this.store.item && this.store.item.id)
    },
    getItem () {
      return this.store.item
    },
    getChildren () {
      return this.store.item && this.store.item.items && this.store.item.items.filter(item => item.type !== 'charges').map((item, idx) => {
        const itemType = this.meta.types[`${item.type}-${item.label}`] ? `${item.type}-${item.label}` : item.type
        const balance = this.store.item.items.filter(item => item.type !== 'charges').slice(0, idx + 1).reduce((pre, current) => {
          const { type, sum, label } = current
          if (this.meta.types[type]) {
            return this.meta.types[type].sign === 'negative' ? (pre - sum) : (pre + sum)
          } else if (this.meta.types[`${type}-${label}`]) {
            return this.meta.types[`${type}-${label}`] ? (pre - sum) : (pre + sum)
          } else {
            return pre + sum
          }
        }, 0)
        return {
          ...item,
          date: {
            value: item.date,
            text: this.$moment(item.date).format('YYYY年MM月DD日')
          },
          type: [
            {
              value: itemType,
              text: this.$mango.bbook.items[itemType] || itemType
            },
            this.$mango.bbook.types[item.label] && {
              value: item.label,
              text: this.$mango.bbook.types[item.label] || item.label
            }
          ],
          sum: {
            value: item.sum,
            text: `¥${item.sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
          balance: {
            value: balance,
            text: `¥${balance}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          }
        }
      })
    },
    hasCharges () {
      return this.store.item && this.store.item.charges && this.store.item.charges.length      
    },
    getCharges () {
      return this.store.item && this.store.item.charges && this.store.item.charges.length && this.store.item.charges.map(it => {
        return {
          ...it,
          children: it.children.length ? it.children.map(child => {
            return {
              ...child,
              label: {
                value: child.label,
                text: this.$mango.bbook.types[child.label] || child.label
              },
              sum: {
                value: child.sum,
                text: `¥${child.sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
              }
            }
          }) : [],
          date: {
            due: {
              value: it.date,
              text: this.$moment(it.date).format('YYYY/MM/DD')
            },
            charged: {
              value: it.children[0] && it.children[0].date,
              text: it.children[0] && this.$moment(it.children[0].date).format('YYYY/MM/DD')
            }
          },
          sum: {
            value: it.sum,
            text: `¥${it.sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          }
        }
      })
    },
    printURL () {
      let uid = (this.store.item && this.store.item.id) ? this.store.item.id.replace('cbook_', '').toUpperCase() : ''
      let cid = this.$route.params.id
      return `https://legacy.sasmango.com/sas/client/${cid}/cbook${(uid ? ('/' + uid) : '')}`
    }
  }
}
</script>

<style lang="scss">
.b-item {
  &:hover {
    background-color: #E0EAF0;
  }
}
.v-list-group {
  .v-list-group__header {
    padding: 0 !important;
  }
  .v-list-item__subtitle {
    font-size: .7rem !important;
  }
}
#clientAccountant {
  #legacy {
    width: 100%;
    height: 100%;
    iframe {
      display: block;
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}
</style>
